import { createSlice } from '@reduxjs/toolkit';

export const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        isOffersModalOpen: false,
        isTrackPricesModalOpen: false,
        isCancellationAndPaymentPolicyModalOpen: false,
        isContactUsModalOpen: false,
        isOfferModalOpen: false,
        isCalendarModalOpen: false,
        isClick2CallModalOpen: false,
        isShareHotelModalOpen: false,
        isTermsAndConditionsModalOpen: false,
        isAreYouSureModalOpen: false,
        isReviewsModalOpen: false,
        isAmenitiesModalOpen: false,
    },
    reducers: {
        openModal: (state, action) => {
            state[`is${action.payload.modalId}Open`] = true;
        },
        closeModal: (state, action) => {
            state[`is${action.payload.modalId}Open`] = false;
        },
    },
});

export const { closeModal, openModal } = modalSlice.actions;
